/* eslint-disable import/no-anonymous-default-export */
import { ContractorOwnerShow } from './ContractorOwnerShow';
import { ContractorOwnerList } from './ContractorOwnerList';
import { ContractorOwnerEdit } from './ContractorOwnerEdit';
import { ContractorOwnerCreate } from './ContractorOwnerCreate';
import { ContractorOwner } from '@/types';

export default {
    list: ContractorOwnerList,
    show: ContractorOwnerShow,
    edit: ContractorOwnerEdit,
    create: ContractorOwnerCreate,
    recordRepresentation: (record: ContractorOwner) =>
        record?.name + ' ' + record?.company_name,
};
